import React from 'react';
import { palette, typography } from '@doer/frontend-components/theme';
import { useResponsiveSizes } from '../../hooks/use-responsive-sizes';

interface StatusTagProps {
  label: string;
  variant?: 'default' | 'overlay';
  size?: 'small' | 'medium';
}

const accent = palette.primitives.purple.purple550;
const accentBg = palette.primitives.purple.purple50;

export const StatusTag: React.FC<StatusTagProps> = ({ label, variant = 'default', size = 'medium' }) => {
  const { spacing } = useResponsiveSizes();

  const heightMap = { small: '20px', medium: '23px' };
  const paddingMap = { small: `0 ${spacing.sm}px`, medium: `0 ${spacing.md}px` };

  const baseStyle: React.CSSProperties = {
    height: heightMap[size],
    borderRadius: '11.5px',
    display: 'inline-flex',
    alignItems: 'center',
    padding: paddingMap[size],
    background: accentBg,
    color: accent,
    fontFamily: typography.fontFamily.ui,
    fontSize: typography.fontSize.sm,
    fontWeight: typography.fontWeight.bold,
    lineHeight: '15px',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap'
  };

  const overlayStyle: React.CSSProperties = variant === 'overlay' ? { boxShadow: '0 2px 8px rgba(0,0,0,0.15)' } : {};

  return <div style={{ ...baseStyle, ...overlayStyle }}>{label}</div>;
};
